import gql from 'graphql-tag';

export default gql`
    query CountLoadsByJobProppant($input: CountLoadsByJobProppantInput) {
        countLoadsByJobProppant(input: $input) {
            count
        }
    }
`;
